import React, { useState } from "react";
import styled from "styled-components";
import aboutimg from "../../Assets/images/img77.jpg";
import Team from "../../Elements/Team";
import PageHeader from "../../Elements/Header";
import TestimonialSlider from "../../Elements/Testimonial";
import Mission from "../../Elements/Mission";

const AboutSection = () => {
  const [showMore, setShowMore] = useState(false);

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  return (
    <>
      <PageHeader
        title="About Us"
        subtitle="Who We Are"
        description="Discover more about Pristine Academic Consultancy, our mission, and how we aim to support students and professionals in their academic journey."
        buttonText="Learn More"
        buttonAction={() => alert("Learn more button clicked!")}
        backgroundImage="images/about.jpeg" // Replace with actual background image
      />

      <Section>
        <Container>
          <Row>
            <TextColumn>
              <Heading>Our Approach</Heading>
              <Description>
                At Pristine Academic Consulting (PAC), we believe that everyone
                has the potential to excel in their educational and professional
                pursuits when provided with the right support and opportunities.
                Founded and led by Dr. Godfrey Mayoka, a distinguished academic
                and researcher, PAC is dedicated to enhancing the global
                competitiveness of African students, researchers, and
                professionals. Our mission and vision are built on a
                three-pronged strategy and values: Professionalism, Integrity,
                and Mentorship.
              </Description>
              <Description>
                <b>Professionalism:</b> We maintain the highest standards of etiquette
                in communication and content delivery, ensuring efficiency in
                time and resource management. 
                </Description>
                

              {showMore ? (
                <>
                  { 
                  <Description>
                <Description>                    
                <b>Integrity:</b> At PAC, we do not engage in shadow-academic writing or complete assignments meant
                for grading on behalf of our clients. Instead, we emphasize that
                our clients must own their work, using our guidance to enhance
                their competence and confidence. 
               
              </Description>
              <Description> 
                <b>Mentorship:</b> Our mentorship
                approach fosters progressive talent and skills development. We
                guide our clients on a transformative journey, enabling them to
                grow from needing support to becoming independent and confident
                professionals capable of excelling in their work. 
                </Description>
                <Description>
                Together,
                these pillars reflect our unwavering commitment to empowering
                individuals to pursue their goals and realize their full
                potential on the global stage.
                </Description>
                </Description> }
                  <ReadMore onClick={toggleShowMore}>Show Less</ReadMore>
                </>
              ) : (
                <>
                  <ReadMore onClick={toggleShowMore}>Read More</ReadMore>
                </>
              )}
            </TextColumn>
            <ImageColumn>
              <ImageWrapper>
                <Image src={aboutimg} alt="About Us" />
              </ImageWrapper>
            </ImageColumn>
          </Row>
          {/* Get Started Button Centered */}
          <ButtonWrapper>
            <GetStarted href="/services">Get Started</GetStarted>
          </ButtonWrapper>
        </Container>
      </Section>
      <Mission />
      <Team />
      <TestimonialSlider />
    </>
  );
};

export default AboutSection;

// Styled Components

const Section = styled.section`
  padding: 20px 20px;
  background: linear-gradient(to right, #ffffff, #f9f9f9);
  font-family: "Poppins", sans-serif;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const TextColumn = styled.div`
  flex: 1;
  min-width: 300px;
  text-align: center;
`;

const Heading = styled.h2`
  font-size: 2.5rem;
  font-weight: 800;
  color: #333333;
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 1px;

  @media (max-width: 768px) {
    font-size: 2.4rem;
  }
`;

const Description = styled.div`
  font-size: 1rem;
  color: #333333;
  line-height: 1.8;
  margin-bottom: 15px;
  text-align: left;
`;

const ReadMore = styled.span`
  font-size: 1rem;
  color: #1565c0;
  cursor: pointer;
  font-weight: 600;
  text-align: left;
  border-radius: 8px;
  display: inline-block;
  transition: all 0.3s ease;

  &:hover {
    color: #003c8f;
    text-decoration: underline;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
`;

const GetStarted = styled.a`
  display: inline-block;
  padding: 12px 30px;
  background-color: #1565c0;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 30px;
  text-decoration: none;
  box-shadow: 0px 4px 8px rgba(21, 101, 192, 0.3);
  transition: all 0.3s ease;

  &:hover {
    background-color: #003c8f;
    transform: translateY(-3px);
    box-shadow: 0px 6px 12px rgba(21, 101, 192, 0.4);
  }
`;

const ImageColumn = styled.div`
  flex: 1;
  min-width: 300px;
`;

const ImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;

  &:hover img {
    transform: scale(1.05);
  }
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  border-radius: 20px;
  transition: transform 0.3s ease;
`;
